<template>
  <div class="wrap reserve-wrap">
    <div class="top-header">
      <incBack></incBack>
      <h3>예약하기</h3>
    </div>
    <div class="body-wrap">
      <h4 v-if="isLoading == 0">
        코칭받고 싶은 주제를 순서대로 <br />
        선택해 주세요.
      </h4>
      <ul class="subject-wrap" v-if="isLoading == 0">
        <div class="question">
          <ul>
            <!-- <li @click="select(item,0)" class="clear" v-for="(item,index) in list[0].sub_list" :key="index" :class="{'active':item.is_active}">
                            <div class="float-left">
                                <span v-if="item.is_active"><b >{{item.order}}</b></span>
                            </div>
                            <p class="float-left">{{item.parentSubject}} - {{item.childSubject}}</p>
                        </li> -->

            <li @click="select(item)" class="clear" v-for="(item, index) in list" :key="index" :class="{ active: item.is_active }">
              <div class="float-left">
                <span v-if="item.is_active"
                  ><b>{{ item.order }}</b></span
                >
              </div>
              <p class="float-left">{{ item.parentSubject }} - {{ item.childSubject }}</p>
            </li>

            <!-- <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">리더십 – 동기부여 및 육성</p>
                        </li>
                        <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">자기관리/웰빙 - 시간관리</p>
                        </li>
                        <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">커뮤니케이션(소통) - 피드백</p>
                        </li> -->
          </ul>
        </div>
      </ul>
      <div class="loading-container mt-50per" v-if="isLoading == 1">
        <div class="loader">
          <div class="loading-spinning-bubbles">
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
            <div class="bubble-container">
              <div class="bubble"></div>
            </div>
          </div>
        </div>
      </div>
      <p class="loading-info" v-if="isLoading == 1">
        {{ userName }}님에게 딱 맞는 <br />
        코치 추천 중…
      </p>
    </div>
    <div class="bnb-btn" v-if="isLoading != 1">
      <!-- 선택 시 class="active" 활성화 -->
      <button class="active" @click="next()">확인</button>
      <p @click="reEmbedded()" v-if="rebook == 0 && $store.state.isRebookEmbedded == false">
        혹시 주제가 맘에 안든다면? <br />
        서베이를 한번 더 해볼 수 있어요!
      </p>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "reserve_subject",
  props: {
    rebook: {
      type: [Number, String],
      default: 0,
    },
    coachIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    isLoading: 0,
    list: [],
    selectData: [],
    input: {
      categoryIdxList: [],
      userIdx: 0,
      courseIdx: 0,
    },
    userName: "",
  }),
  components: {
    incBack,
  },
  mounted() {
    // console.log(this.$store.state.isRebookEmbedded)

    this.userName = this.$store.state.userInfo.userName;
    console.log(JSON.parse(localStorage.getItem("mainSurveyData")));
    console.log(JSON.parse(localStorage.getItem("subSurveyData")));
    this.getUserEmbededSurvey();
  },
  methods: {
    reEmbedded() {
      // console.log(this.$store.state.userInfo.userIdx);

      let form = new FormData();
      form.append("userIdx", this.$store.state.userInfo.userIdx);
      this.axios
        .delete("/front/delete/userembeddedsurvey", { data: form })
        .then((res) => {
          if (res.data.success) {
            localStorage.setItem("mainSurveyData", "");
            localStorage.setItem("subSurveyData", "");
            localStorage.setItem("isEmbedded", "0");
            this.$store.commit("setRebbokEmbedded", true);
            this.$router.push({ name: "embedded_survey" });
          }
        })
        .catch((err) => {
          console.log("ES 초기화 오류", err);
        });
      //  this.axios.delete("/content",{data:params}).then((res)=>{
    },
    getUserEmbededSurvey() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/embedded-survey-list/selected", { params })
        .then((res) => {
          if (res.data.success) {
            this.list = [];
            let i = 0;
            for (let item of res.data.data) {
              item.is_active = false;
              item.order = 0;
              if (i < 2) {
                this.list.push(item);
              } else {
                if (item.childSurveyOrder == "1") {
                  this.list.push(item);
                }
              }
              i++;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    select(item) {
      if (!item.is_active) {
        this.selectData.push(item);
      } else {
        let find_idx = this.selectData.findIndex((obj) => obj.childCategoryIdx == item.childCategoryIdx);
        this.selectData.splice(find_idx, 1);
      }
      for (let item of this.list) {
        let j = 0;
        if (this.selectData.length > 0) {
          for (let subItem of this.selectData) {
            if (item.childCategoryIdx == subItem.childCategoryIdx) {
              item.is_active = true;
              item.order = j + 1;
              break;
            } else {
              item.is_active = false;
              item.order = 0;
            }
            j++;
          }
        } else {
          item.is_active = false;
          item.order = 0;
        }
      }
    },
    next() {
      if (this.selectData.length == 0) {
        alert("코칭 주제를 선택해주세요.");
        return false;
      } else {
        console.log(this.selectData);
        this.input.categoryIdxList = [];
        for (let item of this.selectData) {
          this.input.categoryIdxList.push(item.childCategoryIdx);
        }

        this.input.userIdx = this.$store.state.userInfo.userIdx;
        this.input.courseIdx = this.$store.state.courseInfo.courseIdx;

        let params = this.input;
        this.isLoading = 1;
        this.axios
          .post("/front/user/embedded-survey-insert", params)
          .then((res) => {
            if (res.data.success) {
              localStorage.setItem("recomSubjectData", JSON.stringify(this.selectData));
              // this.$router.push('coach_recom');
              this.$store.commit("setpageFunc", "0");
              this.$store.commit("setIsReRcom", "0");
              this.$store.commit("setIsReCoach", "0");
              if (this.coachIdx != 0) {
                this.$router.push({ name: "coach_view", params: { idx: this.coachIdx, rebook: this.rebook } });
              } else {
                this.$router.push({ name: "coach_recom", params: { rebook: this.rebook } });
              }
            } else {
              alert("Error");
              console.log(res);
            }
          })
          .catch((err) => {
            alert("Error");
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
.bnb-btn {
  position: static;
}
</style>
